import React from 'react';
import { motion } from 'framer-motion';

// Set this once the latest "She Sent Me Her Diet" episode is uploaded -
// e.g. VIDEO_ID = "dQw4w9WgXcQ" (the part after ?v= in the YouTube URL).
const VIDEO_ID = '';

const CHANNEL_URL = 'https://youtube.com/@the_proteinprincess?si=Aou3ATj7lodKbMs3';

const LatestEpisode: React.FC = () => {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="container mx-auto px-6 max-w-2xl text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <p
            className="text-secondary text-xs md:text-sm font-bold uppercase tracking-[0.2em] mb-3"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            She Sent Me Her Diet
          </p>
          <h2
            className="text-2xl md:text-3xl font-bold text-dark mb-8 leading-snug"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            This is what actually happens when you send me yours.
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="rounded-xl overflow-hidden shadow-lg"
          style={{ aspectRatio: '16/9' }}
        >
          {VIDEO_ID ? (
            <iframe
              className="w-full h-full"
              src={`https://www.youtube-nocookie.com/embed/${VIDEO_ID}`}
              title="She Sent Me Her Diet - latest episode"
              loading="lazy"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <div className="w-full h-full bg-primary flex flex-col items-center justify-center gap-3">
              <div className="w-14 h-14 rounded-full bg-white/70 flex items-center justify-center">
                <svg className="w-6 h-6 text-secondary ml-0.5" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M6.3 4.3a1 1 0 011.02-.05l8 5a1 1 0 010 1.7l-8 5A1 1 0 016 15V5a1 1 0 01.3-.7z" />
                </svg>
              </div>
              <p className="text-dark/60 text-sm" style={{ fontFamily: "'Poppins', sans-serif" }}>
                Latest episode coming soon
              </p>
            </div>
          )}
        </motion.div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.3 }}
          className="mt-6 text-dark/70 text-sm md:text-base leading-relaxed"
          style={{ fontFamily: "'Poppins', sans-serif" }}
        >
          Each episode, I break down a real diet someone sent me anonymously — what's working, what's not, and what I'd actually change.
        </motion.p>

        <motion.a
          href={CHANNEL_URL}
          target="_blank"
          rel="noopener noreferrer"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.4 }}
          className="mt-4 inline-block text-dark/70 text-sm underline underline-offset-4 decoration-dark/40 hover:text-secondary hover:decoration-secondary transition-colors duration-200"
          style={{ fontFamily: "'Poppins', sans-serif" }}
        >
          Watch more on YouTube →
        </motion.a>
      </div>
    </section>
  );
};

export default LatestEpisode;
